import React, { useState } from 'react'
import '../Pricing.scss'

const PricingTable = ({ heading, columns, rows, icons, expandable = false, isAddOnsTable = false }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const initialRowsToShow = 5

  const getStatusClass = (status) => {
    if (status === 'included') return 'value_included'
    if (status === 'not_included') return 'value_not_included'
    return 'value_neutral'
  }

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const displayedRows = expandable && !isExpanded ? rows.slice(0, initialRowsToShow) : rows

  return (
    <div className="pricing_section table_variant">
      <h2 className="pricing_section_title">{heading}</h2>
      <div className={`pricing_table ${isAddOnsTable ? 'addons_table' : ''}`}>
        <div className={`pricing_table_header ${isAddOnsTable ? 'addons_header' : ''}`}>
          {isAddOnsTable ? (
            <>
              <div className="table_cell feature_col">Feature</div>
              <div className="table_cell package_col">Pricing</div>
              <div className="table_cell package_col">Details</div>
            </>
          ) : (
            <>
              <div className="table_cell feature_col">Feature</div>
              {columns.map((col) => (
                <div key={col.id} className="table_cell package_col">
                  <div className="pkg_title">{col.title}</div>
                  {col.priceUSD && <div className="pkg_price">{col.priceUSD}</div>}
                  {col.priceINR && <div className="pkg_price_inr">{col.priceINR}</div>}
                </div>
              ))}
            </>
          )}
        </div>

        <div className={`pricing_table_body ${expandable && !isExpanded ? 'collapsed' : ''}`}>
          {displayedRows.map((row) => (
            <div key={row.feature} className={`pricing_table_row ${isAddOnsTable ? 'addons_row' : ''}`}>
              {isAddOnsTable ? (
                <>
                  <div className="table_cell feature_col">{row.values.feature?.text || row.feature}</div>
                  <div className="table_cell package_col">{row.values.pricing?.text || '-'}</div>
                  <div className="table_cell package_col">{row.values.details?.text || '-'}</div>
                </>
              ) : (
                <>
                  <div className="table_cell feature_col">{row.feature}</div>
                  {columns.map((col) => {
                    const value = row.values[col.id] || { text: '-' }
                    const statusClass = getStatusClass(value.status)

                    return (
                      <div key={col.id} className={`table_cell package_col ${statusClass}`}>
                        {value.status === 'included' && icons?.included && (
                          <img src={icons.included} alt="Included" className="status_icon" />
                        )}
                        {value.status === 'not_included' && icons?.notIncluded && (
                          <img src={icons.notIncluded} alt="Not Included" className="status_icon" />
                        )}
                        <span className="value_text">{value.text}</span>
                      </div>
                    )
                  })}
                </>
              )}
            </div>
          ))}
        </div>

        {expandable && (
          <div className="pricing_table_footer">
            <button className="pricing_table_toggle_btn" onClick={handleToggleExpand}>
              {isExpanded ? 'Show Less' : 'Show More'}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className={isExpanded ? 'rotated' : ''}
              >
                <path
                  d="M4 6L8 10L12 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default PricingTable
